export const LAYOUT = {
  // variant: window.matchMedia("(prefers-color-scheme: dark)").matches ? "Dark" : "Light",
  variant: "Light",
  menuPosition: "Side",
  navbar: {
    type: "Static",
  },
};
